<div class="container-fluid margin-top-custom">
  <p-tabView [activeIndex]="tabIndex">
    <p-tabPanel header="{{ 'label.Emails' | translate }}">
      <hr-email-tab-templates-list
        [emailTemplateData]="emailSmsTemplates?.emailTemplates"
      >
      </hr-email-tab-templates-list>
    </p-tabPanel>
    <p-tabPanel header="{{ 'label.SMS' | translate }}">
      <hr-sms-tab-templates-list
        [smsTemplateData]="emailSmsTemplates?.smsTemplates"
      >
      </hr-sms-tab-templates-list>
    </p-tabPanel>
  </p-tabView>
</div>
